/** @jsxImportSource @emotion/react */
import React, { useCallback } from "react";
import { ratesInfo } from "../../config/commonCSS";
import subtract from "../../img/trade-interface/subtract.svg";
import { GlobalStore } from "../../store/global/GlobalStore";
import { calculateFee, getGasCost, getTokenOut } from "../../utils/quoteUtils";

export const NetworkFeeRow: React.FC = () => {
  const theme = GlobalStore.useState(s => s.theme);
  const network = GlobalStore.useState(s => s.network);
  const quote = GlobalStore.useState(s => s.quote);
  const tokenMetadata = GlobalStore.useState(s => s.tokens);

  const FeeToDisplay = useCallback(() => {
    if (quote == null) {
      return <>${getGasCost(quote).format(2)}</>;
    }
    const symbol = getTokenOut(quote);
    if (symbol == null) {
      return <>${getGasCost(quote).format(2)}</>;
    }
    return (
      <>
        {calculateFee(quote).toDisplay(symbol, tokenMetadata)} {symbol} ($
        {getGasCost(quote).format(2)})
      </>
    );
  }, [quote, tokenMetadata]);

  return (
    <>
      <hr className="dashed my-1" />
      <div
        className="d-flex justify-content-between align-items-center"
        data-testid="network-fee-row"
      >
        <div
          className="d-flex align-items-center m-0"
          style={{ color: theme.font.secondary.default }}
        >
          <img src={subtract} className="pe-2" alt={"Network Fee"} />
          {network.name} Fee
        </div>
        <div className="d-flex flex-column align-items-end">
          {!quote && <div className="spinner-bebop-loading" role="status"></div>}
          {quote && (
            <span css={ratesInfo}>
              <FeeToDisplay />
            </span>
          )}
        </div>
      </div>
    </>
  );
};
